var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortZaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.644 8.143h1.928v12.214a.643.643 0 0 0 .643.643H7.5a.643.643 0 0 0 .643-.643V8.143h1.928c.57 0 .86-.691.454-1.097L7.311 3.189a.643.643 0 0 0-.908 0L3.19 7.046c-.406.402-.117 1.097.454 1.097ZM19.713 3H14.57a.643.643 0 0 0-.643.643v1.286a.643.643 0 0 0 .643.642h2.25l-2.463 2.833a1.285 1.285 0 0 0-.43.96v.707a.643.643 0 0 0 .643.643h5.142a.642.642 0 0 0 .643-.643V8.786a.643.643 0 0 0-.643-.643h-2.25l2.463-2.833a1.286 1.286 0 0 0 .43-.96v-.707A.643.643 0 0 0 19.713 3Zm1.249 17.105-2.382-6.43a.643.643 0 0 0-.607-.425H16.31a.643.643 0 0 0-.606.426l-2.383 6.429a.643.643 0 0 0 .607.86h.996a.643.643 0 0 0 .61-.447l.178-.518h2.852l.177.518a.642.642 0 0 0 .618.446h.997a.643.643 0 0 0 .606-.86Zm-4.479-2.355.659-1.929.659 1.929h-1.318Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortZaIcon);
export default __webpack_public_path__ + "static/media/sort-za-icon.597896142165474e231bd30f71aebf73.svg";
export { ForwardRef as ReactComponent };